// extracted by mini-css-extract-plugin
module.exports = {"img":"HomeBannerImage_img__EOsgi","mobile":"HomeBannerImage_mobile__fBRo8","desktop":"HomeBannerImage_desktop__McyRH"};